import { render, staticRenderFns } from "./AccountsNotices.vue?vue&type=template&id=02c83d18&scoped=true&"
import script from "./AccountsNotices.vue?vue&type=script&lang=js&"
export * from "./AccountsNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c83d18",
  null
  
)

export default component.exports